/* OBSERVER IDENTIFIERS */
/** The player's inventory has changed */
export const OBS_INVENTORY_CHANGE = "OBS_INVENTORY_CHANGE";
/** The active order at the front of the queue has been complete */
export const OBS_ORDER_COMPLETE = "OBS_ORDER_COMPLETE";
/** A new active order is now at the front of the queue */
export const OBS_NEW_ACTIVE_ORDER = "OBS_NEW_ACTIVE_ORDER";
